import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { deleteContentLibraryFileRequested } from 'features/content-library/actions';

export function* deleteContentLibraryFileSaga(
  action: ReturnType<typeof deleteContentLibraryFileRequested>
) {
  yield call(SignalingSocket.send, { event: 'deleteLibraryFile', data: action.payload });
}
